import { useCallback, useEffect, useState } from "react";
import * as siteContentService from "../services/siteContentService";
import {
  defaultSiteContent,
  normalizeSiteContent,
  SiteContent,
} from "../types/siteContent";

const siteContentWithoutDefaultEventImages = normalizeSiteContent({
  ...defaultSiteContent,
  events: [],
});

export function useSiteContent() {
  const [content, setContent] = useState<SiteContent>(
    siteContentWithoutDefaultEventImages,
  );
  const [loading, setLoading] = useState(true);
  const [backendUnavailable, setBackendUnavailable] = useState(false);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await siteContentService.getSiteContent();
      setContent(normalizeSiteContent(data));
      setBackendUnavailable(false);
    } catch (_error) {
      setContent(siteContentWithoutDefaultEventImages);
      setBackendUnavailable(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    content,
    setContent,
    loading,
    refresh,
    backendUnavailable,
  };
}
